export default __webpack_public_path__ + "static/media/Intersection 2_imac2013_right.49c53b8c.png";